module.exports = __webpack_public_path__ + "static/media/doreen_parsons-smith.e4f2ba3a.pdf";